var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pre',{directives:[{name:"highlightjs",rawName:"v-highlightjs"}]},[_vm._v("    "),_c('code',{class:_vm.lang},[_vm._v("\n        "),_vm._t("default"),_vm._v("\n    ")],2),_vm._v("\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }